import type { TFunction } from 'i18next';

export interface IVisibilityToggleCopy {
  label: string;
  helpText: string;
  modalTitle: string;
  modalIntro: string;
  modalBullets: string[];
  confirmButtonText: string;
  successMessage: string;
  errorMessage: string;
}

/**
 * Centralized, single-source copy for the Hide/Restore project control.
 */
export function getVisibilityToggleCopy(isHidden: boolean, t: TFunction): IVisibilityToggleCopy {
  return {
    label: isHidden ? t('Restore project') : t('Hide project'),
    helpText: isHidden
      ? t(
          'This project has been hidden from your projects list. You can restore it to see it again.',
        )
      : t(
          'If you hide this project you will no longer see it in your projects list. The associated campaigns will keep running and the billing configurations will remain unchanged. You can restore it at any time.',
        ),
    modalTitle: t('Hide this project?'),
    modalIntro: t('Hiding this project will:'),
    modalBullets: [
      t('Hide it from your projects list'),
      t('Keep its campaigns, data, and billing unchanged'),
      t('Let you restore it anytime'),
    ],
    confirmButtonText: t('Hide'),
    successMessage: isHidden ? t('Project hidden.') : t('Project restored.'),
    errorMessage: t('Something went wrong while updating the project.'),
  };
}
